import React from 'react'
import Slider from 'lib/ui/Slider'
import {Controller, UseFormMethods} from 'react-hook-form'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import styled from 'styled-components'
import {WidgetButton} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetButton'

const DEFAULT_BUTTON_HEIGHT = 45
const DEFAULT_BUTTON_WIDTH = 250

export default function SizeSection(props: {
  control: UseFormMethods['control']
  button: WidgetButton
  storageKey: string
  maxWidth?: number
}) {
  const {button, control, maxWidth = 1000} = props

  return (
    <CollapsibleSection label="Size" storageKey={props.storageKey}>
      <Content>
        <Controller
          name="height"
          defaultValue={button.height || DEFAULT_BUTTON_HEIGHT}
          control={control}
          render={({value, onChange}) => (
            <Slider
              min={1}
              max={400}
              onChange={onChange}
              valueLabelDisplay="off"
              value={value}
              label="Height"
            />
          )}
        />
        <Controller
          name="width"
          defaultValue={button.width || DEFAULT_BUTTON_WIDTH}
          control={control}
          render={({value, onChange}) => (
            <Slider
              min={1}
              max={maxWidth}
              onChange={onChange}
              valueLabelDisplay="off"
              value={value}
              label="Width"
            />
          )}
        />
      </Content>
    </CollapsibleSection>
  )
}

const Content = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[4]};
`
